import { render, staticRenderFns } from "./cliente-sidebar.vue?vue&type=template&id=b966c68c&scoped=true&"
import script from "./cliente-sidebar.vue?vue&type=script&lang=js&"
export * from "./cliente-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./cliente-sidebar.vue?vue&type=style&index=0&id=b966c68c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b966c68c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b966c68c')) {
      api.createRecord('b966c68c', component.options)
    } else {
      api.reload('b966c68c', component.options)
    }
    module.hot.accept("./cliente-sidebar.vue?vue&type=template&id=b966c68c&scoped=true&", function () {
      api.rerender('b966c68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/cliente-sidebar.vue"
export default component.exports